import { Box, Fade, IconButton, Modal, Paper, Typography } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import CreateCreditNote from "../../pages/PrimeFigma/CreateCreditNote";
import { padding } from "@mui/system";

const style = {
  position: "absolute",
  left: "5%",
  right: "5%",
  // transform: 'translate(-50%, -50%)',
  // bgcolor: "background.paper",
  boxShadow: 24,
  paddingBottom: 2,
  outline: "none",
  height: "93vh",
 
};

function AddPNFCreditNote({ open, setOpen, accountDetails }) {
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
      localStorage.removeItem("modalOpen")
    }
  };
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      onClose={handleClose}
    >
      <Fade in={open}>
        <Paper sx={style}>
          <Box
            sx={{
              backgroundColor: "primary.main",
              padding: "5px 15px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                Add Credit Note
                <IconButton aria-label="delete" onClick={handleClose}>
                  <CloseIcon sx={{ color: "#fff" }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>

          <Box
            className="custom-scrollbar"
            sx={{ overflow: "scroll", height: "80vh", padding:"10px" }}
          >
            <CreateCreditNote
              isVoucher={handleClose}
              accountDetails={accountDetails}
            />
          </Box>
        </Paper>
      </Fade>
    </Modal>
  );
}

export default AddPNFCreditNote;
